<template>
  <div class="qr">
    <div class="qr-image" :style="{ width: size + 'px', height: size + 'px' }">
      <svg v-if="path" :viewBox="viewBox" xmlns="http://www.w3.org/2000/svg" role="img" :aria-label="'QR code for ' + value" shape-rendering="crispEdges">
        <rect :width="dimension" :height="dimension" fill="#FFFFFF" />
        <path :d="path" fill="#1F2328" />
      </svg>
    </div>
    <div v-if="downloads" class="qr-actions">
      <button type="button" class="pb-button outline sm" :disabled="!path" @click="downloadPng"><i class="mdi mdi-download pb-ico" aria-hidden="true"></i>PNG</button>
      <button type="button" class="pb-button outline sm" :disabled="!path" @click="downloadSvg"><i class="mdi mdi-download pb-ico" aria-hidden="true"></i>SVG</button>
    </div>
  </div>
</template>

<script>
import qrcodegen from '../lib/qrcodegen';

const QUIET = 4;

export function qrModules(text) {
  const code = qrcodegen.QrCode.encodeText(String(text || ''), qrcodegen.QrCode.Ecc.MEDIUM);
  const modules = [];
  for (let y = 0; y < code.size; y++) {
    const row = [];
    for (let x = 0; x < code.size; x++) row.push(code.getModule(x, y));
    modules.push(row);
  }
  return modules;
}

export default {
  name: 'QrCode',
  props: {
    value: { type: String, required: true },
    size: { type: Number, default: 168 },
    filename: { type: String, default: 'trustclap-qr' },
    downloads: { type: Boolean, default: true }
  },
  computed: {
    modules() {
      try { return this.value ? qrModules(this.value) : []; } catch (error) { return []; }
    },
    dimension() { return this.modules.length + QUIET * 2; },
    viewBox() { return '0 0 ' + this.dimension + ' ' + this.dimension; },
    path() {
      const parts = [];
      this.modules.forEach((row, y) => row.forEach((dark, x) => {
        if (dark) parts.push('M' + (x + QUIET) + ' ' + (y + QUIET) + 'h1v1h-1z');
      }));
      return parts.join('');
    }
  },
  methods: {
    svgText() {
      return '<?xml version="1.0" encoding="UTF-8"?>\n<svg xmlns="http://www.w3.org/2000/svg" viewBox="' + this.viewBox
        + '" width="1024" height="1024" shape-rendering="crispEdges"><rect width="100%" height="100%" fill="#FFFFFF"/><path d="'
        + this.path + '" fill="#000000"/></svg>\n';
    },
    save(blob, extension) {
      const url = URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = this.filename + '.' + extension;
      document.body.appendChild(anchor);
      anchor.click();
      anchor.remove();
      window.setTimeout(() => URL.revokeObjectURL(url), 5000);
    },
    downloadSvg() {
      this.save(new Blob([this.svgText()], { type: 'image/svg+xml' }), 'svg');
    },
    downloadPng() {
      const pixels = 1024;
      const canvas = document.createElement('canvas');
      canvas.width = pixels;
      canvas.height = pixels;
      const context = canvas.getContext('2d');
      context.fillStyle = '#FFFFFF';
      context.fillRect(0, 0, pixels, pixels);
      const scale = pixels / this.dimension;
      context.fillStyle = '#000000';
      this.modules.forEach((row, y) => row.forEach((dark, x) => {
        if (!dark) return;
        const left = Math.floor((x + QUIET) * scale);
        const top = Math.floor((y + QUIET) * scale);
        context.fillRect(left, top, Math.ceil((x + QUIET + 1) * scale) - left, Math.ceil((y + QUIET + 1) * scale) - top);
      }));
      canvas.toBlob(blob => { if (blob) this.save(blob, 'png'); }, 'image/png');
    }
  }
};
</script>

<style scoped>
.qr{display:flex;flex-direction:column;align-items:flex-start;gap:12px}
.qr-image{padding:6px;border-radius:12px;background:#fff;border:1px solid #E6DED2;box-sizing:content-box}
.qr-image svg{display:block;width:100%;height:100%}
.qr-actions{display:flex;gap:8px;flex-wrap:wrap}
</style>
